import React, { Component } from 'react';
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Alert, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './ApiKeys.css';

import { Auth } from '../../support';
import { useStore } from '../../store';
import { FormControl } from '../../facturotopia';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';

class ApiKeys extends Component {
  state = {
    showCopyProduction: false,
    showCopySandbox: false,
  };

  constructor(props) {
    super(props);

    const { empresa = {} } = Auth.getData();

    this.state = {
      data: { ...empresa },
    };

    props.apikeysActions.reset();
    props.apikeysActions.setPartialState({ data: { ...this.state.data } });
  }

  componentDidMount() {
    const { data } = this.state;

    this.props.apikeysActions.info(data.id, { include: 'api_keys' });
  }

  handleOnClickProduction = (event) => {
    const {
      data: { api_keys = {} },
    } = this.props.apikeys;

    const field = document.createElement('textarea');
    field.innerText = api_keys.production;
    document.body.appendChild(field);
    field.select();

    document.execCommand('copy');

    event.target.focus();

    field.remove();

    this.setState(
      {
        showCopyProduction: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCopyProduction: false,
          });
        }, 1500);
      }
    );
  };

  handleOnClickSandbox = (event) => {
    const {
      data: { api_keys = {} },
    } = this.props.apikeys;

    const field = document.createElement('textarea');
    field.innerText = api_keys.sandbox;
    document.body.appendChild(field);
    field.select();

    document.execCommand('copy');

    event.target.focus();

    field.remove();

    this.setState(
      {
        showCopySandbox: true,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCopySandbox: false,
          });
        }, 1500);
      }
    );
  };

  handleSandboxApiKeyRotation = (action) => {
    if (action === 'confirm') {
      this.props.apikeysActions.rotate('test');
    }
  };

  handleProductionApiKeyRotation = (action) => {
    if (action === 'confirm') {
      this.props.apikeysActions.rotate('live');
    }
  };

  render() {
    const { showCopyProduction, showCopySandbox } = this.state;
    const {
      busy,
      rotating,
      data: { nombre, api_keys = {} },
    } = this.props.apikeys;

    if (busy) {
      return <Loading />;
    }

    return (
      <>
        <h5>API Keys</h5>

        <Alert variant="info">
          <strong>Importante: </strong>
          Por ningún motivo coloques tus API Keys en código de aplicaciones móviles, de escritorio ni en páginas web.
          Utilízalas únicamente del lado del servidor y en variables de entorno. Cualquiera que tenga acceso a tus{' '}
          <strong>api keys</strong> podrá <strong>emitir y cancelar</strong> facturas a nombre de tu empresa.
        </Alert>

        <div className="row col">
          <p>
            Las siguientes API keys solo pueden ser usadas por la empresa: <strong>{nombre}</strong>
          </p>
        </div>

        <div className="mb-1">
          <strong className="text-info">PRODUCCIÓN</strong>

          <FormControl
            value={api_keys.production}
            readOnly={true}
          >
            {!!showCopyProduction && (
              <Badge
                variant="info"
                className="badge-copy"
              >
                Copiado
              </Badge>
            )}
          </FormControl>

          <Button
            type="button"
            variant="secondary"
            className="mr-2"
            onClick={this.handleOnClickProduction}
          >
            <FontAwesomeIcon icon={['far', 'clipboard']} /> Copiar
          </Button>

          {Guardian.allows('api-keys.renovar.produccion') && (
            <PopConfirm
              text="Confirmas la rotación del Api Key?"
              onAction={this.handleProductionApiKeyRotation}
            >
              <LoadingButton
                type="button"
                variant="secondary"
                loading={!!rotating && rotating === 'live'}
              >
                <FontAwesomeIcon icon={['fas', 'sync']} /> Renovar
              </LoadingButton>
            </PopConfirm>
          )}
        </div>

        <div className="py-4"></div>

        <div className="mb-1">
          <strong className="text-info">SANDBOX</strong>

          <FormControl
            value={api_keys.sandbox}
            readOnly={true}
          >
            {!!showCopySandbox && (
              <Badge
                variant="info"
                className="badge-copy"
              >
                Copiado
              </Badge>
            )}
          </FormControl>

          <Button
            type="button"
            variant="secondary"
            className="mr-2"
            onClick={this.handleOnClickSandbox}
          >
            <FontAwesomeIcon icon={['far', 'clipboard']} /> Copiar
          </Button>

          {Guardian.allows('api-keys.renovar.sandbox') && (
            <PopConfirm
              text="Confirmas la rotación del Api Key?"
              onAction={this.handleSandboxApiKeyRotation}
            >
              <LoadingButton
                type="button"
                variant="secondary"
                loading={!!rotating && rotating === 'test'}
              >
                <FontAwesomeIcon icon={['fas', 'sync']} /> Renovar
              </LoadingButton>
            </PopConfirm>
          )}
        </div>
      </>
    );
  }
}

const mapState = (store) => {
  return { apikeys: store.cuenta.apikeys };
};

const mapActions = (actions) => {
  return { apikeysActions: actions.cuenta.apikeys };
};

export default connect(useStore, mapState, mapActions)(ApiKeys);
